import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import cx from 'classnames';
import './Accordion.styles.less';

class Accordion extends Component {
  state = {
    selectedItem: undefined
  };

  handleClick = () => idx => () => {
    this.setState(prevState => ({ selectedItem: prevState.selectedItem === idx ? undefined : idx }));
  }

  render() {
    const { items } = this.props;
    const { selectedItem } = this.state;

    // Return early if no data
    if (isEmpty(items)) {
      return null;
    }

    return (
      <div className="mpr-accordion">
        {items.map((item, index) => (
          <div
            key={index}
            className={cx(
              'mpr-accordion__section',
              { 'mpr-accordion--selected': index === selectedItem }
            )}
          >
            <h4
              onClick={this.handleClick()(index)}
              className={cx(
                'mpr-accordion__heading',
                { 'mpr-accordion--active': index === selectedItem }
              )}
            >
              <i className={cx(item.icon, 'mpr-accordion__accordion-icon')} />
              <span className="mpr-accordion__title">
                {item.heading}
              </span>
              <span className="mpr-accordion__chevron">
                <i className={cx(
                  'mpr-accordion__zolaicon-public',
                  { 'zolaicon-chevron-up': index === selectedItem },
                  { 'zolaicon-chevron-down': index !== selectedItem }
                )}
                />
              </span>
            </h4>
            <div className="mpr-accordion__body">
              <item.body {...item.props} />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

Accordion.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    body: PropTypes.func,
    props: PropTypes.shape({})
  })),
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/DropDownForms/Accordion/Accordion.jsx